import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';
import BreadcrumbData = App.DTOs.BreadcrumbData;

export function useBreadcrumbTitle() {
  const page = usePage();

  return computed(() => {
    const breadcrumbData: BreadcrumbData[] = [...(page.props.breadcrumbs || [])];

    /*
     * Ensure that 'Admin' breadcrumb is always at the start of the title.
     */
    if (breadcrumbData[0]?.route === 'admin.index') {
      const adminCrumb = breadcrumbData.shift();
      breadcrumbData.push(adminCrumb!);
    }

    return breadcrumbData
      .reverse()
      .map((crumb) => crumb.label)
      .join(' - ');
  });
}
